import React, { useState, useEffect } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  IconButton,
  CircularProgress,
  Modal,
  Button,
} from "@mui/material";
import { IoMdRadioButtonOn } from "react-icons/io";
import { FaLocationDot } from "react-icons/fa6";
import { IoMdTime } from "react-icons/io";
import { FaBagShopping } from "react-icons/fa6";
import { FaBox } from "react-icons/fa";
import { FaMapLocationDot } from "react-icons/fa6";
import { FaBezierCurve } from "react-icons/fa";
import { GoSearch } from "react-icons/go";
import { ClosedDelivery } from "../closedDeliveries";
import { ReallotedDelivery } from "../reallotedDeliveries";
import { NewDelivery } from "../newDeliveries";
import { InprogressDelivery } from "./inprogressDeliveries";
import { OutforDelivery } from "./outforDelivery";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { styled } from "@mui/material/styles";
import { axiosInstance } from "../../../axiosInstance";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  Box,
} from "@mui/material";
import { FaDownload } from "react-icons/fa6";

const stepsForQuick = [
  { label: "New Order", key: "new_order" },
  { label: "Payment Due", key: "payment_due" },
  { label: "Payment Success", key: "payment_success" },
  { label: "Accepted by Ryder", key: "accepted_by_ryder" },
  { label: "Out for Delivery", key: "out_for_delivery" },
  { label: "Delivered", key: "delivered" },
];

const stepsForDelivery = [
  { label: "New Order", key: "new_order" },
  { label: "Payment Due", key: "payment_due" },
  { label: "Payment Success", key: "payment_success" },
  { label: "Order Picked", key: "picked" },
  { label: "Out for Delivery", key: "out_for_delivery" },
  { label: "Delivered", key: "delivered" },
];

// Custom Step Icon to change default color
const GreenStepIcon = styled(CheckCircleIcon)(({ theme }) => ({
  color: "#34C759",
}));

const columns = [
  // { id: "delivery_id", label: "DELIVERY ID", minWidth: 170, align: "center" },
  { id: "order_id", label: "ORDER ID", minWidth: 170, align: "center" },
  {
    id: "delivery_show_id",
    label: "DELIVERY SHOW ID",
    minWidth: 170,
    align: "center",
  },
  { id: "ryder_id", label: "RYDER ID", minWidth: 170, align: "center" },
  {
    id: "pick_up_location",
    label: "PICKUPLOCATION",
    minWidth: 200,
    align: "center",
  },
  {
    id: "drop_location",
    label: "DROP LOCATION",
    minWidth: 170,
    align: "center",
  },
  {
    id: "created_at",
    label: "DELIVERY SLOT TIME",
    minWidth: 170,
    align: "center",
  },
  // { id: "no_of_pack", label: "NO OF PACKS", minWidth: 130, align: "center" },
  {
    id: "vehicle_type",
    label: "VECHICLE TYPE",
    minWidth: 130,
    align: "center",
  },
  { id: "action", label: "ACTION", minWidth: 130, align: "center" },
];

function createData(
  delivery_id,
  delivery_show_id,
  ryder_id,
  pick_up_location,
  drop_location,
  delivered_time,
  no_of_pack,
  action
) {
  return {
    delivery_id,
    delivery_show_id,
    ryder_id,
    pick_up_location,
    drop_location,
    delivered_time,
    no_of_pack,
    action,
  };
}

const rows = [
  createData(
    "#AB1234",
    "#GMKDP123",
    "Shiva Sai Agencies",
    "Vasavi Traders",
    "10:30-11:00",
    "Bag",
    "04"
  ),
];

export function TrackDelivery() {
  const { delivery_id } = useParams();

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [trackDeliveryList, setTrackDeliveryList] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [waybillLink, setWaybillLink] = useState(null);

  const navigate = useNavigate();

  const fetchTrackDelivery = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await axiosInstance.get(
        // `/admin/deliveries/${delivery_id}/`
        `/admin/track-orders/${delivery_id}/`
      );
      console.log("✅ TrackDelivery list response:", res.data);
      if (res.data.status === "success") {
        setTrackDeliveryList(res.data.data || []);
      } else {
        setError("Failed to fetch TrackDelivery data.");
      }
    } catch (err) {
      console.error("❌ Error fetching TrackDelivery data:", err);
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTrackDelivery();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // function formatDateTime(dateString) {
  //   if (!dateString) return "--";

  //   try {
  //     // Split date and time
  //     const [datePart, timePart, meridian] = dateString.split(" ");

  //     // Extract year, month, day
  //     const [year, month, day] = datePart.split("-");

  //     // Return formatted as DD/MM/YYYY HH:MM AM/PM
  //     return `${day}/${month}/${year} ${timePart} ${meridian}`;
  //   } catch (error) {
  //     return "--";
  //   }
  // }

  function formatDateTime(dateString) {
    if (!dateString) return "--";

    try {
      // Example input: "2025-10-22 02:42 PM"
      const [datePart, timePart, meridian] = dateString.split(" ");
      const [year, month, day] = datePart.split("-");

      // Return formatted as DD/MM/YYYY HH:MM AM/PM
      return `${day}/${month}/${year} ${timePart} ${meridian}`;
    } catch (error) {
      return "--";
    }
  }

  // Fetch Waybill link
  useEffect(() => {
    if (trackDeliveryList?.orderitem_id) {
      axiosInstance
        .get(`/wholesaler/waybill-pdflink/${trackDeliveryList.orderitem_id}/`)
        .then((res) => {
          if (res.data?.status === "success") {
            setWaybillLink(res.data.data);
          }
        })
        .catch((err) => console.error("Error fetching waybill link:", err));
    }
  }, [trackDeliveryList?.orderitem_id]);

  const farDelivery = trackDeliveryList?.far_delivery_status;

  function formatDateTime(dateString) {
    if (!dateString) return "--";

    try {
      // Example input: "2025-10-22 02:42 PM"
      const [datePart, timePart, meridian] = dateString.split(" ");
      const [year, month, day] = datePart.split("-");

      // Return formatted as DD/MM/YYYY HH:MM AM/PM
      return `${day}/${month}/${year} ${timePart} ${meridian}`;
    } catch (error) {
      return "--";
    }
  }

  function formatDateTimeISO(dateString) {
    if (!dateString) return "--";

    const date = new Date(dateString);
    if (isNaN(date)) return "--";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    const hh = String(hours).padStart(2, "0");

    return `${day}/${month}/${year} ${hh}:${minutes} ${ampm}`;
  }

  return (
    <div>
      <div className="delivery-top-container">
        <div className="admin-listText">Tracking Status </div>
        {/* <div>
          <select
            className="listAdmin-showRecords"
            value={rowsPerPage}
            onChange={handleChangeRowsPerPage}
          >
            <option value={20}>Show No of Records</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={500}>500</option>
            <option value={1000}>1000</option>
            <option value={2000}>2000</option>
            <option value={5000}>5000</option>
          </select>
        </div> */}
        {/* <div className="search-container">
          <div className="nav-search ">
            <span className="search-icons">
              <GoSearch />
            </span>
            <input type="text" placeholder="Search"></input>
          </div>
        </div> */}
      </div>
      <div className="btnContainer">
        <button
          style={{
            // backgroundColor: "#FF961F",
            backgroundColor: "#1265c5",
            color: "white",
            display: "flex",
          }}
          onClick={() => navigate("/out-for-delivery")}
        >
          <FaMapLocationDot style={{ marginRight: "8px" }} />
          Track Your Orders
        </button>
        <button
          // style={{ backgroundColor: "#34C759", color: "white" }}
          style={{ backgroundColor: "#E8E8E9" }}
          onClick={() => navigate("/delivery")}
        >
          Unassigned
        </button>
        <button
          // style={{ backgroundColor: "#FF961F", color: "white" }}
          style={{ backgroundColor: "#E8E8E9" }}
          onClick={() => navigate("/inprogress-delivery")}
        >
          {/* In Process */}
          Re-Assign
        </button>
        <button
          style={{ backgroundColor: "#E8E8E9" }}
          onClick={() => navigate("/closed-delivery")}
        >
          Delivered
        </button>
        {/* <button
                style={{ backgroundColor: "#1265C5", color: "white" }}
                onClick={() => navigate("/realloted-delivery")}
              >
                ReAlloted
              </button> */}
      </div>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <Box sx={{ width: "100%", overflowX: "auto" }}>
          <TableContainer
            sx={{
              maxHeight: 640,
              minWidth: 1800,
              overflowX: "auto",
            }}
            className="Table-container"
          >
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : trackDeliveryList ? (
                  <TableRow hover>
                    {columns.map((column) => {
                      // const value = trackDeliveryList[column.id];
                      const value =
                        trackDeliveryList[column.id] !== null &&
                        trackDeliveryList[column.id] !== undefined &&
                        trackDeliveryList[column.id] !== ""
                          ? trackDeliveryList[column.id]
                          : "--";
                      return (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          className="tableCelldata"
                          onClick={
                            column.id === "order_id"
                              ? () =>
                                  navigate(
                                    // `/closed-delivery-details/${delivery_id}`
                                    `/closed-delivery-details/${delivery_id}`
                                  )
                              : undefined
                          }
                          sx={{
                            cursor:
                              column.id === "order_id" ? "pointer" : "default",
                            color: column.id === "order_id" ? "#4184D1" : "",
                          }}
                        >
                          {column.id === "pick_up_location" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <IoMdRadioButtonOn
                                style={{ fontSize: "18px", color: "#34C759" }}
                              />
                              {value}
                            </div>
                          ) : column.id === "drop_location" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <FaLocationDot
                                style={{ fontSize: "18px", color: "#F52D56" }}
                              />
                              {value}
                            </div>
                          ) : column.id === "delivered_time" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <IoMdTime
                                style={{ fontSize: "18px", color: "#FF961F" }}
                              />
                              <span
                                style={{
                                  border: "1px solid rgb(168, 199, 231)",
                                  padding: "5px",
                                  borderRadius: "5px",
                                }}
                              >
                                {formatDateTime(value) || "--"}
                              </span>
                            </div>
                          ) : column.id === "vehicle_type" ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              {value === "Bag" ? (
                                <FaBezierCurve
                                  style={{ fontSize: "18px", color: "#FF961F" }}
                                />
                              ) : (
                                <FaBezierCurve
                                  style={{ fontSize: "18px", color: "#FF961F" }}
                                />
                              )}
                              {value}
                            </div>
                          ) : column.id === "action" ? (
                            <Button
                              variant="contained"
                              size="small"
                              style={{
                                backgroundColor: "#FF961F",
                                color: "white",
                              }}
                              onClick={() => navigate("/out-for-delivery")}
                            >
                              Tracking
                            </Button>
                          ) : (
                            value
                          )}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No Data Available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      {/* Delivery List status detailes  */}
      {trackDeliveryList?.delivery_type === "far_delivery" && (
        <Box sx={{ maxWidth: 900, margin: "auto", mt: 5 }}>
          <div className="deliveredContainer">
            <div className="gridContainer">
              <div className="topRow">
                <div className="box1">
                  <span>
                    <b>Delivered Type</b> :
                  </span>{" "}
                  <span>
                    {trackDeliveryList?.delivery_type
                      ? trackDeliveryList.delivery_type
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase())
                      : "--"}
                  </span>
                </div>

                <div className="box3">
                  <div className="deliHeading">Waybill Details</div>
                  <div className="smallGrid">
                    <div>
                      <b>Way Bill No</b>:
                    </div>
                    <div>{trackDeliveryList?.waybill || "--"}</div>

                    <div>
                      <b>Download Way Bill</b>:
                    </div>
                    <div>
                      {waybillLink ? (
                        <IconButton
                          onClick={() => window.open(waybillLink, "_blank")}
                          color="primary"
                          aria-label="download"
                        >
                          <FaDownload style={{ fontSize: "16px" }} />
                        </IconButton>
                      ) : (
                        "--"
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="box2">
                <div className="deliHeading">
                  Far Delivery (Current Status):
                </div>
                <div className="smallGrid">
                  <div>
                    <b>Status</b>:
                  </div>
                  <div>{farDelivery?.status || "--"}</div>

                  <div>
                    <b>Status Date</b>:
                  </div>
                  <div>
                    {farDelivery?.status_date
                      ? formatDateTimeISO(farDelivery.status_date)
                      : "--"}
                  </div>

                  <div>
                    <b>Instructions</b>:
                  </div>
                  <div>{farDelivery?.instruction || "--"}</div>

                  <div>
                    <b>Location</b>:
                  </div>
                  <div>{farDelivery?.location || "--"}</div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      )}

      {/* Stepper content */}
      {/* <Box sx={{ maxWidth: 400, margin: "auto", mt: 5 }}>
        <Stepper orientation="vertical">
          {steps.map((step, index) => {
            const stepTime = trackDeliveryList?.order_history?.[step.key];
            return (
              <Step key={step.key} active={!!stepTime}>
                <StepLabel
                  StepIconComponent={GreenStepIcon}
                  sx={{
                    color: "#1A1C1E",
                    fontWeight: "600",
                    fontSize: "14px",
                  }}
                >
                  {step.label}
                </StepLabel>
                {stepTime && (
                  <StepContent>
                    <Typography
                      sx={{
                        color: "#666768",
                        fontWeight: "500",
                        fontSize: "12px",
                      }}
                    >
                      {stepTime}
                    </Typography>
                  </StepContent>
                )}
              </Step>
            );
          })}
        </Stepper>
      </Box> */}

      <Box sx={{ maxWidth: 400, margin: "auto", mt: 5 }}>
        <Stepper orientation="vertical">
          {(trackDeliveryList?.delivery_type === "far_delivery"
            ? stepsForDelivery
            : stepsForQuick
          ).map((step) => {
            const stepTime = trackDeliveryList?.order_history?.[step.key];
            return (
              <Step key={step.key} active={!!stepTime}>
                <StepLabel
                  StepIconComponent={GreenStepIcon}
                  sx={{
                    color: "#1A1C1E",
                    fontWeight: 600,
                    fontSize: "14px",
                  }}
                >
                  {step.label}
                </StepLabel>

                {stepTime && (
                  <StepContent>
                    <Typography
                      sx={{
                        color: "#666768",
                        fontWeight: 500,
                        fontSize: "12px",
                      }}
                    >
                      {stepTime}
                    </Typography>
                  </StepContent>
                )}
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </div>
  );
}
